import React from 'react'
import './Home.css'
import {ExternalLinks} from "./ExternalLinks"
import CoursesInfo from "./CoursesInfo"
import {YoutubePlayLists} from "./YoutubePlayLists"
import {SeriesBanner} from "./SeriesBanner"
import {CourseMap} from "./CourseMap"
import CourseClasses from "./courseClasses.json"
/*
const SectionTitle = (props: {imgUrl: string, title: string}) => (
    <div className="row">
        <div className="col-md-4 col-12 py-2 pl-4">
            <img src={props.imgUrl} width="100%" alt="cpp"/>
        </div>
        <div className="col-md-8 col-12">
            <div className="series">{props.title}</div>
        </div>
    </div>
)
*/

const CourseEntry = (course: any, index: any) => {
    const hasDate = (course.date && course.date.length > 0)
    const link = <a rel="noopener noreferrer" target="_blank" href={"https://docs.google.com/forms/d/e/1FAIpQLSfBEFBcRQsq7rA1X12x12y3LQnNc4iCh3_gyoEd56Nwor72Gw/viewform"}>我有興趣</a>
    return (
        <div key={"course_entry_" + index} className={"row py-2" + (index % 2 === 0 ? " even" : "")}>
            <div className="col-lg-5 col-md-5 col-7 border-right">
                <a style={{fontSize: "1.1em"}} href={course.url} target="_blank" rel="noopener noreferrer">{course.title}</a>
            </div>
            <div className="course_date col-lg-2 col-md-3 col-5" style={{lineHeight: "1.6em"}}>
                {hasDate ? (course.enrolling ? <a className="font-weight-bold" rel="noopener noreferrer"  href={course.url} target="_blank">{course.date[0]}</a> : course.date[0]) : ""}
            </div>
            <div className="col-12 d-md-none d-flex" style={{padding: "2px"}}>
            </div>
            <div className="col-lg-3 d-lg-flex col-7 d-md-none border-left" style={{fontSize: "0.95em"}}>
                {course.hours}
            </div>
            <div className="col-lg-3 d-lg-none d-md-flex d-none col-md-2 col-7 border-left">
                {course.hours}
            </div>
            <div className="col-lg-2 col-md-2 col-5 border-left">
                {course.enrolling ? <a className="font-weight-bold" rel="noopener noreferrer"  href={course.url} target="_blank">{course.status || "招生中"}</a> : (course.underSurvey ? link : (course.repeated ? <span style={{fontSize: "0.8em"}}>{ course.repeated }</span> : ""))}
            </div>
        </div>
    )
}
const ContentEntry = (
    courses: any) => (
    <div className="row mx-1">
        <div className="col-12">
            {courses.map((e: any, i: number) => CourseEntry(e, i))}
        </div>
    </div>
)


// 《駕馭程式代理人》同一門課開好幾個班別（週六下午班、週二夜間班……），版面跟 C++ 系列一致：一班一列，
// 班別寫在課程總長度欄，日期只寫開課日，train 站已開班的日期與狀態連到報名頁。
// 資料來自 csie-train 的課表（scripts/sync-course-classes.mjs 產生 courseClasses.json）；
// 兩個月內開課的班每種班別列最近一梯，兩到三個月的只列招生中的，都沒有才列最近一班；已開課、三個月後開課、期數還沒定的班不列，所以隔天重新整理就會自動換成下一梯。
type CourseClass = {term: string, class: string, train_id: number | null, dates: string[], slots: {start: string, end: string, dates: string[]}[]}
const dateString = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
// 今天起 n 個月後的日期（11/1 起兩個月是 1/1、三個月是 2/1）。在瀏覽器依當天日期算，不必靠重新建置
const monthsLater = (n: number) => {
    const d = new Date()
    d.setMonth(d.getMonth() + n)
    return dateString(d)
}
// 班別名稱標出下午或夜間（照課表第一堂的開始時間，19:00 以後算夜間）：週六班 → 週六下午班，週二夜間班不變
const classLabel = (c: CourseClass) =>
    c.class.replace(/(夜間)?班$/, "") + (c.slots[0].start >= "19:00" ? "夜間班" : "下午班")
// 把每門課展開成 CourseEntry 吃的一列一列：一班一列；三個月內沒有班就留一列只有課名
const classRows = (courses: any[]) => {
    const today = dateString(new Date())
    const soon = monthsLater(2)
    const limit = monthsLater(3)
    return courses.flatMap((course): any[] => {
        const all: CourseClass[] = (CourseClasses.courses as {[title: string]: CourseClass[]})[course.title] || []
        // 候選：還沒開課（第一堂在今天之後）、三個月內開課、期數已定的班（all 已依開課日排序）
        const upcoming = all.filter((c) => c.term !== "期數未定" && c.dates[0] > today && c.dates[0] <= limit)
        // 每種班別只列最近一梯：兩個月內開課的一律列；兩到三個月之間的只列 train 站已開班招生的；
        // 都沒有可列時，才列三個月內最近的那一班
        const seen = new Set<string>()
        const pick = (c: CourseClass) => {
            if (seen.has(classLabel(c))) return false
            seen.add(classLabel(c))
            return true
        }
        const listed = [
            ...upcoming.filter((c) => c.dates[0] <= soon && pick(c)),
            ...upcoming.filter((c) => c.dates[0] > soon && c.train_id && pick(c)),
        ].sort((a, b) => a.dates[0].localeCompare(b.dates[0]))
        const classes = listed.length > 0 ? listed : upcoming.slice(0, 1)
        if (classes.length === 0) return [{title: course.title, hours: course.hours, date: []}]
        return classes.map((c) => ({
            title: course.title,
            // 班別跟時數寫在同一欄，比照 C++「約 18 小時 / 179 部影片」的寫法
            hours: course.hours + " / " + classLabel(c),
            // 日期一律寫完整的「2026/11/01」；只有 train 站已開班的才有連結與狀態
            date: [c.dates[0].replace(/-/g, " / ")],
            url: c.train_id ? "https://train.csie.ntu.edu.tw/school/courses/course.php?id=" + c.train_id : undefined,
            enrolling: !!c.train_id,
        }))
    })
}
const SimpleSection = (
    props: {
            children: any
    }) => (
    <div className="card border-dark mb-3">
            <div className="row mx-1 font-weight-bold py-2 d-md-flex d-none">
                    <div className="col-lg-12 col-md-12">
                            <div className="row d-md-flex d-none">
                                    <div className="col-lg-5 col-md-5 border-right">課程名稱</div>
                                    <div className="col-lg-2 col-md-3 col-6">下次開課日期</div>
                                    <div className="col-lg-3 col-md-2 col-3 border-left">課程總長度</div>
                                    <div className="col-lg-2 col-md-2 col-3 border-left"></div>
                            </div>
                    </div>
            </div>
            {props.children}
    </div>
)
/*
const Section = (
    props: {
            imgUrl: string,
            title: string,
            children: any
    }) => (
    <div className="card border-dark mb-3">
            <SectionTitle imgUrl={props.imgUrl} title={props.title}/>
            <div className="row mx-1 font-weight-bold py-2 d-md-flex d-none">
                    <div className="col-lg-12 col-md-12">
                            <div className="row d-md-flex d-none">
                                    <div className="col-lg-5 col-md-5 border-right">課程名稱</div>
                                    <div className="col-lg-2 col-md-3 col-6">預計開課日期</div>
                                    <div className="col-lg-3 col-md-2 col-3 border-left">課程影片總長度</div>
                                    <div className="col-lg-2 col-md-2 col-3 border-left"></div>
                            </div>
                    </div>
            </div>
            {props.children}
    </div>
)
*/

const Home = () => (
    <div className="container p-0">
        <img className="img-fluid d-block mt-3 border mx-auto" src="logo.png" alt="logo"/>
        <ExternalLinks />
        <div className="card border-dark mb-3">
            <div className="card-header">
                關於我
            </div>
            <div className="row pl-3">
                <div className="col-md-4 col-12 text-center pt-4 align-self-start">
                    <div className="row">
                        <div className="col">
                            <img src="me.jpg" width="220" className="border" alt="me"/>
                        </div>
                    </div>
                    <div className="row py-3">
                        <div className="col">
                            李根逸 博士<br/>Dr. Feis Ken-Yi Lee
                        </div>
                    </div>
                </div>
                <div className="col-md-8 col-12 pr-5 pl-0">
                    <ul className="list-group list-group-flush">
                    
                        <li className="list-group-item" style={{fontSize: "1.1em"}}>
                            <a href="https://train.csie.ntu.edu.tw/train/teacher.php?id=4"
                                target="_blank"
                                rel="noopener noreferrer">國立臺灣大學資訊系統訓練班</a>資深講師<br/><span style={{fontSize: "0.8em"}}>(因興趣長期從事程式設計推廣教育，已有十九年、五千小時以上的課堂教學經驗)</span>
                        </li>

                        <li className="list-group-item" style={{fontSize: "1.1em"}}>
                            <a href="https://management.ntu.edu.tw/IM/faculty/teacher/sn/419"
                               target="_blank"
                               rel="noopener noreferrer">國立臺灣大學資訊管理學系</a>兼任助理教授<br/><span style={{fontSize: "0.8em"}}>(教授 「資料結構與進階程式設計 (IM1010)」與「遊戲設計 (IM5023)」課程)</span>
                               <br/><span style={{fontSize: "0.8em"}}>(獲國立臺灣大學 113 和 112 學年度全校兼任教師教學優良獎)</span>
                        </li>

                        <li className="list-group-item" style={{fontSize: "1.1em"}}>
                            <a href="http://www.sigono.com/"
                               target="_blank"
                               rel="noopener noreferrer">信革數位 (SIGONO)</a> 技術總監<br/><span style={{fontSize: "0.8em"}}>(負責架構設計並帶領技術團隊)</span>
                        </li>

                        <li className="list-group-item" style={{padding: "10px"}}>學經歷</li>
                        
                        <li className="list-group-item" style={{fontSize: "1.1em"}}>
                            <a href="https://www.csie.ntu.edu.tw/"
                                                           target="_blank"
                               rel="noopener noreferrer">國立臺灣大學資訊工程所</a>博士<br/><span style={{fontSize: "0.8em"}}>(專長領域為電腦視覺、電腦圖學、影像處理與機器學習) [<a href="https://scholar.google.com/citations?user=zTU8IJIAAAAJ&hl=en"
                                                                                                                                                                               target="_blank"
                                                                                                                                                                               rel="noopener noreferrer">Google Scholar</a>]</span>
                        </li>
                        <li className="list-group-item" style={{fontSize: "1.1em"}}><a
                            href="https://www.rayark.com/"
                            target="_blank"
                            rel="noopener noreferrer">雷亞遊戲 (Rayark) </a>技術總監<br/>
                            <span style={{fontSize: "0.8em"}}>(負責架構設計並帶領小型技術與機器學習團隊)</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div className="p-2">
            <SeriesBanner title="駕馭程式代理人" subtitle="實體課程系列"/>
        </div>
        <SimpleSection>
            {ContentEntry(classRows(CoursesInfo.MasteringCodingAgents))}
        </SimpleSection>
        <div className="p-2">
            <CourseMap/>
        </div>
        <SimpleSection>
            {ContentEntry(CoursesInfo.CppBasics)}
        </SimpleSection>
        <div className="p-2">
            <SeriesBanner title="工程師核心素養" subtitle="線上課程系列"/>
        </div>
        <SimpleSection>
            {ContentEntry(CoursesInfo.CoreCompetencies)}
        </SimpleSection>
        <div className="card border-dark mb-3">
            <div className="card-header">
                過往演講分享投影片
            </div>
            <div className="row">
                <div className="col-lg-6 text-center">
                    <div className="card border-dark m-3">
                        <div className="card-header">分享於台北遊戲開發者論壇<br/>(TGDF 2026)</div>
                        <div className="card-body">
                            <a href="/d/mountain-time-machine"
                               target="_blank"
                               rel="noopener noreferrer"><img src="/images/mountain-time-machine.png" width="100%" alt="talk"/></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 text-center">
                    <div className="card border-dark m-3">
                        <div className="card-header">分享於台北遊戲開發者論壇<br/>(TGDF 2023)</div>
                        <div className="card-body">
                            <a href="https://docs.google.com/presentation/d/e/2PACX-1vSZnmYFydQJnCjRbE1n1akSEcPeBOCv6pW4ZyvAGjy3G8w39sH77Ac8a4Pyu7288tY6XYzcr02ny1nc/pub?slide=id.p"
                               target="_blank"
                               rel="noopener noreferrer"><img src="tgdf_2023.png" width="100%" alt="talk"/></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 text-center">
                    <div className="card border-dark m-3">
                        <div className="card-header">分享於台北 Tensorflow 使用者社群<br/>(TFUG Taipei)</div>
                        <div className="card-body">
                            <a href="https://docs.google.com/presentation/d/e/2PACX-1vT-RHZD7MJN6izs2Grbk4yFlw6rKdxGJUQaNi0sBP2HK6Vs29iBgsCzdrIYvyAdYLMCuhToUre8eUEF/pub?slide=id.p"
                               target="_blank"
                               rel="noopener noreferrer"><img src="talk_4.png" width="100%" alt="talk"/></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 text-center">
                    <div className="card border-dark m-3">
                        <div className="card-header">分享於開源人年會<br/>(COSCUP 2019)</div>
                        <div className="card-body">
                            <a href="https://docs.google.com/presentation/d/e/2PACX-1vSOpX-sZT_54NdnngdtaJUwnQjoVvju45oS-sIGHcnzhX_LTMb7KHVa7lCJIrx2qZewdA43pI8jALgl/pub"
                               target="_blank"
                               rel="noopener noreferrer"><img src="talk_3.png" width="100%" alt="talk"/></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 text-center">
                    <div className="card border-dark m-3">
                        <div className="card-header">分享於台北遊戲開發者論壇<br/>(TGDF 2019)</div>
                        <div className="card-body">
                            <a href="https://docs.google.com/presentation/d/e/2PACX-1vQk8RfZxqA4KlRdO_EKyL7x7Fk3asRU4RhMS53WSGzjWxBkq5T0yfxzloCJ7_5oO-CBYzfca4_aQy3q/pub"
                               target="_blank"
                               rel="noopener noreferrer"><img src="talk_2.png" alt="talk" width="100%"/></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 text-center">
                    <div className="card border-dark m-3">
                        <div className="card-header">分享於成功大學資訊工程系</div>
                        <div className="card-body">
                            <a href="https://docs.google.com/presentation/d/e/2PACX-1vQ17_XtJHkJnASHbmmuDgUr0hr6bN5c7A6VHMCZTz1PTE8Rkv9R-0qMeTImoyZEfeYAr-T7GXyhLhGD/pub"
                               target="_blank"
                               rel="noopener noreferrer"><img src="talk_1.png" alt="talk" width="100%"/></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 text-center">
                    <div className="card border-dark m-3">
                        <div className="card-header">分享於中央創遊社</div>
                        <div className="card-body">
                            <a href="https://docs.google.com/presentation/d/e/2PACX-1vRN4bzcR5D_sLwId4GvVQNhEgjvgpDTwLh7sF68-4KYFZTljbvuUqPNbBVuF6dQxF0YDAFlMPxuTmsU/pub"
                               target="_blank"
                               rel="noopener noreferrer"><img src="unity_1.png" alt="talk" width="100%"/></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <YoutubePlayLists />
        <footer className="page-footer font-small blue">
            <div className="footer-copyright text-center py-3">© 2024 Copyright <a href="http://feis.studio" target="_blank" rel="noopener noreferrer" className="mx-1">Feis Studio</a> (<a href="mailto:feis.studio@gmail.com"
                                                                                                                                                                                            target="_blank" rel="noopener noreferrer">feis.studio@gmail.com</a>)
            </div>
        </footer>
    </div>
)

export default Home